$(document).ready(function () {
    const $variantSelects = $('.brgo-award-variant-select');
    const $surveyDataContent = $('#survey-data-content');
    const $selectedPrizesInput = $('#winner_form_selectedPrizes');

    $surveyDataContent.hide();

    function updateSelectedPrizes()
    {
        const selectedPrizes = {};
        let allSelected = true;

        $variantSelects.each(function () {
            const awardId = $(this).data('award-id');
            const selectedValue = $(this).val();

            if (selectedValue && selectedValue !== '') {
                selectedPrizes[awardId] = selectedValue;
                $('#winner_form_variant_' + awardId).val(selectedValue);
            } else {
                allSelected = false;
            }
        });
        $selectedPrizesInput.val(JSON.stringify(selectedPrizes));

        if (allSelected) {
            $surveyDataContent.slideDown();
        } else {
            $surveyDataContent.slideUp();
        }
    }

    $variantSelects.on('change', function () {
        updateSelectedPrizes();
    });

    $variantSelects.each(function () {
        const awardId = $(this).data('award-id');
        const variantValue = $('#winner_form_variant_' + awardId).val();
        if (variantValue) {
            $(this).val(variantValue);
        }
    });

    updateSelectedPrizes();

    const modal = document.getElementById('imageModal');
    if (modal) {
        const modalImg = modal.querySelector('img');
        const closeBtn = modal.querySelector('.image-modal-close');

        document.querySelectorAll('.prize-image').forEach(function (picture) {
            picture.addEventListener('click', function () {
                const imgSrc = this.getAttribute('data-image');
                modalImg.src = imgSrc;
                modal.classList.add('active');
            });
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                modal.classList.remove('active');
            });
        }

        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                modal.classList.remove('active');
            }
        });
    }

    $('form').on('submit', function () {
        $(this).find('.btn-red[type="submit"]').prop('disabled', true);
    });
});